'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var scroll_service = require('../scroll/scroll.service.js');
var modal_constants = require('./modal.constants.js');
var magicMessages = require('@gig/magic-messages');

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
class ModalService {
  constructor() {
    this.idCount = 0;
    this.modals = new Set();
    this.listeners = new Set();
  }
  open(header, body, options = {}) {
    options = __spreadValues({
      dismissible: true,
      dismissibleBackdrop: true,
      size: modal_constants.ModalSize.DEFAULT
    }, options);
    const modal = {
      header,
      body: this.getBodyNode(body),
      options,
      id: this.idCount++
    };
    this.modals.add(modal);
    this.modalsChanged(modal.id);
    return modal;
  }
  replace(modal, body, options = null, header = void 0) {
    if (!this.modals.has(modal)) {
      this.open(header || null, body, options || {});
      return;
    }
    modal.header = header !== void 0 ? header : modal.header;
    modal.body = this.getBodyNode(body);
    modal.options = options !== null ? options : modal.options;
    this.modalsChanged(modal.id);
  }
  updateOptions(modal, options = null) {
    modal.options = options !== null ? options : modal.options;
  }
  close(modal, closeButton = false, params) {
    if (!this.modals.has(modal)) {
      return;
    }
    if (modal.options && modal.options.onClose) {
      modal.options.onClose(closeButton, params);
    }
    this.modals.delete(modal);
    this.modalsChanged(modal.id);
  }
  onModalsChange(handler) {
    this.listeners.add(handler);
    handler(this.getClonedModals());
    return () => {
      this.listeners.delete(handler);
    };
  }
  getBodyNode(body) {
    if (typeof body === "string") {
      return document.createTextNode(body);
    }
    return body;
  }
  modalsChanged(modalId) {
    if (this.modals.size === 0) {
      scroll_service.scroll.enableScrolling();
    } else if (this.modals.size === 1) {
      scroll_service.scroll.disableScrolling();
    }
    this.listeners.forEach((handler) => {
      handler(this.getClonedModals(), modalId);
    });
  }
  getClonedModals() {
    const modals = Array.from(this.modals);
    const modalOnTop = modals.find((m) => {
      var _a;
      return (_a = m.options) == null ? void 0 : _a.displayOnTop;
    });
    if (!modalOnTop) {
      return modals;
    }
    return modals.filter((m) => {
      var _a;
      return !((_a = m.options) == null ? void 0 : _a.displayOnTop);
    }).concat(modalOnTop);
  }
  initialise() {
    window.commandBus.subscribe(magicMessages.CLEAR_MODALS, () => {
      const modalsAfterClear = [];
      Array.from(this.modals).forEach((modal) => {
        var _a;
        if ((_a = modal.options) == null ? void 0 : _a.keepAfterClear) {
          modalsAfterClear.push(modal);
        } else if (modal.options && modal.options.onClose) {
          modal.options.onClose(false);
        }
      });
      this.modals.clear();
      this.modals = new Set(modalsAfterClear);
      this.modalsChanged();
    });
  }
}
const modalService = new ModalService();

exports.ModalService = ModalService;
exports.modalService = modalService;
